var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['Vlt-composite', _vm.className]},[(_vm.hasPrepend)?_c('div',{staticClass:"Vlt-composite__prepend"},[_vm._t("prepend")],2):_vm._e(),_vm._t("default"),(_vm.hasAppend)?_c('div',{staticClass:"Vlt-composite__append"},[_vm._t("append")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }